module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/purchase/payment-approval/payment-approval-form/payment-approval-form.component.css
// module id = ./src/app/Pages/purchase/payment-approval/payment-approval-form/payment-approval-form.component.css
// module chunks = main